import { map, Observable, Subscriber } from 'rxjs';
import { SocketClientEventData } from './Models/SocketClientEventData';
import { SocketData } from './Models/SocketData';
import { SocketServerEventResponse } from './Models/SocketServerEventResponse';
import { SmoSocketServer } from './SmoSocketServer';
import { SocketManager } from './SocketManager';

export class SmoSocketManager extends SmoSocketServer implements SocketManager {
  public listen$<Event extends string, Response extends SocketServerEventResponse<Event>>(
    event: Event
  ): Observable<Response[Event]> {
    return this.fromSocketEvent$(event).pipe(map((data) => data as Response[Event]));
  }

  public emit$<Event extends string, Data extends SocketClientEventData<Event>>(
    event: Event,
    data?: Data[Event]['arguments']
  ): Observable<Data[Event]['response']> {
    return this.fromSocketEmit$<Data[Event]['response']>(event, data);
  }

  private fromSocketEvent$<T>(event: string): Observable<T> {
    return new Observable<T>((subscriber: Subscriber<T>) => {
      this.socket.on(event, (data: T) => subscriber.next(data));
    });
  }

  private fromSocketEmit$<T>(event: string, data?: object): Observable<T> {
    return new Observable<T>((subscriber: Subscriber<T>) => {
      this.socket.emit(event, data, (data: SocketData<T>) => {
        subscriber.next(data.data);
        subscriber.complete();
      });
    });
  }
}
